import React from 'react';
import { Box } from '@mui/material';
import ActionDialog from '../../globalModals/ActionDialog';
import SupportForm from './SupportForm';
import { GlobalDialogProps } from '../../../types';

interface SupportFormDialogProps extends GlobalDialogProps {
  formSource?: string;
}

const SupportFormDialog: React.FC<SupportFormDialogProps> = ({
  onClose,
  formSource = 'Contact Support Dialog',
}) => {
  return (
    <ActionDialog
      title="Contact Support"
      open
      onClose={onClose}
      maxWidth="md"
      fullWidth
      actions={[]}
    >
      <Box>
        <SupportForm formSource={formSource} />
      </Box>
    </ActionDialog>
  );
};

export default SupportFormDialog;
